import { LandingContext } from "./context";

const { Consumer: LandingContextConsumer } = LandingContext;

export { LandingContextConsumer };
